jQuery.noConflict();
(function($) {



	// ------------------------------------------------------------------------------------------------
	// functions
	// ------------------------------------------------------------------------------------------------

	// mobile size function ---------------------------------------------------------------------------
	// transform the css :before content to a class
	// get have a class for media query breakpoints
	// with this no screen sizes must be set in the js functions

	function classMobile() {
		var size = window.getComputedStyle(document.body, ':before').getPropertyValue('content');

		size = size.replace(/"/g, '');

		if (size == 'mobile') {
			$('body').addClass('mobile');
			$('body').removeClass('tablet');
		} else if (size == 'tablet') {
			$('body').addClass('tablet');
			$('body').removeClass('mobile');
		} else {
			$('body').removeClass('mobile');
			$('body').removeClass('tablet');
		}
	}
	// tables ------------------------------------------------------------------------------------------
	// table overflow functions
	// copy elements for a fixed first column (and remove them)
	// collapse a table in a list: store table head content in data attributes
	function tableFixedColumn() {
		// first reset the table state, may it was manipulated
		$('.table-flex .table-wrapper')
			.removeClass('has-overflow')
			.removeClass('no-overflow');
		$('.table-flex .table-wrapper.fixed-column td, .content-table.fixed-column th').removeClass('hidden-column');
		$('.table-flex .table-wrapper.fixed-column .fixed-column').remove();

		// check if the table has an overflow
		$('.table-flex .table-wrapper').each(function() {
			// check if there is an overflow of the table
			var tableScrollerWidth = $(this)
				.find('.table-scroller')
				.innerWidth();

			var table = $(this).find('table');
			var tableWidth = '';
			// 	var tableWidth = $(this).find('table')[0].scrollWidth; // get the total with of the table with scroll width: [0].scrollWidth;
			if (typeof table[0] !== 'undefined') {
				tableWidth = table[0].scrollWidth; // get the total with of the table with scroll width: [0].scrollWidth;
			}

			tableScrollerWidth = tableScrollerWidth.toFixed(0);

			// console.log('tableScrollerWidth' + tableScrollerWidth);
			// console.log('tableWidth' + tableWidth);

			if (tableScrollerWidth < tableWidth) {
				$(this).addClass('has-overflow');
			} else {
				$(this).addClass('no-overflow');
			}
		});

		// tables of type fixed-column cone the first column to fix it
		// use the 2nd column to get the wrapping height of the elements
		// clone elements for an fixed first columns
		$('.table-flex .table-wrapper.fixed-column.has-overflow tr td:first-child').each(function() {
			$(this)
				.clone()
				.prependTo($(this).parent())
				.addClass('fixed-column')
				.next()
				.addClass('hidden-column');
		});

		$('.table-flex .table-wrapper.fixed-column.has-overflow tr th:first-child').each(function() {
			$(this)
				.clone()
				.prependTo($(this).parent())
				.addClass('fixed-column')
				.next()
				.addClass('hidden-column');
		});
		// end fixed-column -----------------------------------

		// table collapse -------------------------------------
		// table overflow functions
		// add the table head content to each table cell item as data value
		$('.table-flex .table-wrapper.table-collapse th').each(function() {
			var tableHeadIndex = $(this).index() + 1; // nth child is not zero based so + 1 !
			var tableHeadContent = $(this).text();

			$(this)
				.closest('table')
				.find('tbody tr')
				.each(function() {
					if (tableHeadContent == '') {
						$(this)
							.find('td:nth-child(' + tableHeadIndex + ')')
							.addClass('no-head-value');
					} else {
						$(this)
							.find('td:nth-child(' + tableHeadIndex + ')')
							.attr('data-head-content', tableHeadContent);
					}
				});
		});
		// end table collapse ---------------------------------
	}
	// ------------------------------------------------------------------------------------------------

	// select menu functions --------------------------------------------------------------------------
	// pseudo select menu with a list of radio buttons
	// select option from the menu
	// this function needs an on click event, to allow to add custom events to the select click
	function pseudoSelect(thisElement) {
		var clickedSelection = $(thisElement).text();
		//console.log('option:' + clickedSelection);
		$(thisElement)
			.closest('.select-menu')
			.toggleClass('close-select')
			.toggleClass('open-select')
			.prev('input')
			.attr('checked', true);

		// close other opend selects
		$(thisElement)
			.closest('.select-menu')
			.find('li')
			.removeClass('selected');
		$(thisElement)
			.closest('.select-menu')
			.find('input')
			.attr('checked', false);
		$(thisElement)
			.parent()
			.addClass('selected');
		$(thisElement)
			.prev()
			.attr('checked', true);

		$(thisElement)
			.closest('.select-menu')
			.find('.current-selection')
			.html(clickedSelection);
		if (
			$(thisElement)
			.prev()
			.hasClass('all')
		) {
			$(thisElement)
				.closest('.select-menu')
				.addClass('no-selection')
				.removeClass('has-selection');
			//console.log('select all');
		} else {
			$(thisElement)
				.closest('.select-menu')
				.removeClass('no-selection')
				.addClass('has-selection');
			// console.log('select once');
		}

		$('.select-menu')
			.addClass('close-select')
			.removeClass('open-select');
		$(this)
			.parent()
			.toggleClass('close-select')
			.toggleClass('open-select');
	}

	// toggle the select menu
	function pseudoSelectToggle() {
		$(document).on('click', '.select-menu .current-selection', function() {
			//var thisElement = this;
			$('.select-menu')
				.addClass('close-select')
				.removeClass('open-select');
			$(this)
				.parent()
				.toggleClass('close-select')
				.toggleClass('open-select');
		});
	}

	// close select menu on click outside of the menu
	function pseudoSelectCloseOutside() {
		$(document).bind('mouseup touchend', function(e) {
			var container = $('.select-menu'); // YOUR CONTAINER SELECTOR

			if (
				!container.is(e.target) && // if the target of the click isn't the container...
				container.has(e.target).length === 0
			) {
				// ... nor a descendant of the container
				$('.select-menu')
					.addClass('close-select')
					.removeClass('open-select');
			}
		});
	}

	// close select menu on click outside of a label
	function pseudoSelectCloseOutsideLabel() {
		$(document).on('click', '.select-menu ul', function() {
			$(this)
				.closest('.select-menu')
				.toggleClass('close-select')
				.toggleClass('open-select');
		});
	}

	// clear the selection and close the menu
	function pseudoSelectClear(thisElement) {
		//$(document).on('click', '.select-menu .form-clear', function() {
		var defaultValue = $(thisElement)
			.closest('form')
			.find('.current-selection')
			.attr('data-selection-all');
		$(thisElement)
			.closest('form')
			.find('li')
			.removeClass('selected');
		$(thisElement)
			.closest('form')
			.find('input')
			.attr('checked', false);
		$(thisElement)
			.closest('form')
			.find('.all')
			.attr('checked', true);
		$(thisElement)
			.closest('form')
			.removeClass('has-selection')
			.addClass('no-selection');
		$(thisElement)
			.closest('form')
			.find('.current-selection')
			.html(defaultValue);

		// console.log('defaultValue' + defaultValue);

		//});
	}


	// load press release list with ajax --------------------------------------------------------------
	function ajax_press_release(press_release_anchor_section_select, press_release_year_select) {
		// console.log('ajax start');
		$.ajax({
			type: 'POST',
			url: sgn_ajax_object.ajax_url,
			data: {
				action: 'press_release_list_function',
				press_release_anchor_section_select: press_release_anchor_section_select,
				press_release_year_select: press_release_year_select,
				nonce: sgn_ajax_object.nonce,
			},
		}).done(function(data) {
			// dev only for testing
			//console.log('ajax_press_release done' + data);

			// update the event list;
			$('.press-release-list ul').html(data);
		});
	}
	// ------------------------------------------------------------------------------------------------

	// load press release list with ajax --------------------------------------------------------------
	function ajax_members_news(members_news_anchor_section_select, members_news_year_select) {
		// console.log('ajax start');
		$.ajax({
			type: 'POST',
			url: sgn_ajax_object.ajax_url,
			data: {
				action: 'members_news_list_function',
				members_news_anchor_section_select: members_news_anchor_section_select,
				members_news_year_select: members_news_year_select,
				nonce: sgn_ajax_object.nonce,
			},
		}).done(function(data) {
			// dev only for testing
			//	console.log('members_news_list_function done' + data);

			// update the event list;
			$('.press-release-list ul').html(data);
		});
	}
	// ------------------------------------------------------------------------------------------------


	// call the functions ------------------------------------------------------------------------------
	// important: keep the this order of calling the functions first navMenu, last contentMarginTop

	classMobile(); // add body class for mobile sizes

	//  scrollSnapPager(); // call pager for snap scroll items function
	tableFixedColumn(); // check if table has an overflow and cone cells for a fixed first columns
	// marginal_margin_top(); // correct the margin, when the text content has a headline
	// ------------------------------------------------------------------------------------------------

	// switch to flexbox after slider init to get a correct autoHeight calc sentential -----------------
	// after init add a class flex
	// ggf. auf bind umstellen
	$(document).on('cycle-pre-initialize cycle-initialize cycle-pre-initialize', '.tab-item', function(event, opts) {
		$('.tab-item .cycle-carousel-wrap, .teaser-group .cycle-carousel-wrap').addClass('flex');
	});
	// ------------------------------------------------------------------------------------------------


	// select menu -------------------------------------------------------------------------------------------
	// pseudo select menu with a list of radio buttons
	$(document).on('click', ':not(.calendar-filters):not(#member-applications) .select-menu label', function() {
		// select option from the menue
		var thisElement = this;
		pseudoSelect(thisElement);
	});

	// toggle the select menu
	pseudoSelectToggle();

	// close select menu on click outside of the menu
	pseudoSelectCloseOutside();

	// close select menu on click outside of a label
	pseudoSelectCloseOutsideLabel();

	// clear the selection and close the menu
	pseudoSelectClear();

	// ------------------------------------------------------------------------------------------------

	// ajax member news
	// select menu for the calendar with ajax call
	// one for the label
	$(document).on('click', '.members-news-filters .select-menu label', function() {
		pseudoSelect(this);

		var members_news_anchor_section_select = $('.members-news-anchor_section .selected input').val();
		var members_news_year_select = $('.members-news-year .selected input').val();

		// console.log('x members_news_anchor_section_select' + members_news_anchor_section_select);
		// console.log('x members_news_year_select' + members_news_year_select);

		ajax_members_news(members_news_anchor_section_select, members_news_year_select);
	});

	// one for the clear function
	$(document).on('click', '.members-news-filters .select-menu .form-clear', function() {
		pseudoSelectClear(this);

		var members_news_anchor_section_select = $('.members-news-anchor_section .selected input').val();
		var members_news_year_select = $('.members-news-year .selected input').val();

		ajax_members_news(members_news_anchor_section_select, members_news_year_select);
	});
	// ------------------------------------------------------------------------------------------------

	// ajax press release
	// select menu for the calendar with ajax call
	// one for the label
	$(document).on('click', '.press-release-filters .select-menu label', function() {
		pseudoSelect(this);

		var press_release_anchor_section_select = $('.press-release-anchor_section .selected input').val();
		var press_release_year_select = $('.press-release-year .selected input').val();

		// console.log('press_release_anchor_section_select' + press_release_anchor_section_select);
		// console.log('press_release_year_select' + press_release_year_select);

		ajax_press_release(press_release_anchor_section_select, press_release_year_select);
	});

	// one for the clear function
	$(document).on('click', '.press-release-filters .select-menu .form-clear', function() {
		pseudoSelectClear(this);

		var press_release_anchor_section_select = $('.press-release-anchor_section .selected input').val();
		var press_release_year_select = $('.press-release-year .selected input').val();

		ajax_press_release(press_release_anchor_section_select, press_release_year_select);
	});
	// ------------------------------------------------------------------------------------------------

	$(document).on('change', '#confrim_gdpr_note', function() {
		var confrim_gdpr_note = $("input[name~='confrim_gdpr_note']").prop('checked');
		if (confrim_gdpr_note === false) {
			var gdpr_error_message = $('#confrim_gdpr_note').data('gdpr-error-message');
			if ($('.gdpr-error').length == 0) {
				$('.press-material-access-from form .error').append('<span id="gdpr-error">' + gdpr_error_message + '</span>');
			}
		} else {
			$('#gdpr-error').remove();
		}
	});

	// event gdpr confirm checkbox error
	$(document).on('change', '.event-confirm-gdpr-note', function() {
		var confrim_gdpr_note = $(this).prop('checked');
		if (confrim_gdpr_note === false) {
			var gdpr_error_message = $(this).data('gdpr-error-message');
			if ($(this).closest('.event-item').find('.event-gdpr-error').length == 0) {
				$(this).closest('.event-item').find('.messages').append('<span class="event-gdpr-error">' + gdpr_error_message + '</span>');
			}
		} else {
			$(this).closest('.event-item').find('.event-gdpr-error').remove();
		}
	});


	// calendar accordion ------------------------------------------------------------------------------------
	$('.event-content-extended').hide();

	// open and close the accordion with click on the item
	$(document).on('click', '.has-extendet-content .event-content', function() {
		$(this)
			.next()
			.slideToggle(400)
			.addClass('open')
			.removeClass('close');

		$(this)
			.parent()
			.siblings()
			.removeClass('content-extended-open');
		$(this)
			.parent()
			.toggleClass('content-extended-open');
		$(this)
			.parent()
			.siblings()
			.find('.event-content-extended')
			.slideUp(400)
			.removeClass('open')
			.addClass('close');

		window.location.hash = $(this).parent().attr("id");
	});

	// close the accordion with the button on content end
	$(document).on('click', '.calendar-accordion', function() {
		$(this)
			.parent()
			.removeClass('content-extended-open');
		$(this)
			.parent()
			.find('.event-content-extended')
			.slideUp(400)
			.removeClass('open')
			.addClass('close');
	});
	// ------------------------------------------------------------------------------------------------

	// helper functions --------------------------------------------------------------------------------
	function is_touch_decvice_bodyclass() {
		const is_touch_device = window.matchMedia("(hover: none),(pointer: coarse)").matches;
		$('body').addClass(is_touch_device ? 'touch-device' : 'none-touch-device');
	}

	function toggleAttr(element, attr, value1, value2) {
		element.attr(attr, function(index, attrValue) {
			return attrValue === value1 ? value2 : value1;
		});
	}

	function viewportHeight() {
		return $(window).height() / 100;
	}

	//--------------------------------------------------------------------------------



	//--------------------------------------------------------------------------------
	// set class touch none touch device
	is_touch_decvice_bodyclass();


	$(function() {
		var $themeBtn = $('#theme-mode-toggle');
		var $contrastBtn = $('#site-contrast-toggle');
		var $body = $('body');

		// 1) Initial Load: Werte aus localStorage auslesen
		var savedTheme = localStorage.getItem('theme') || 'light';
		var savedContrast = localStorage.getItem('highContrast') === 'true';

		// 2) Theme-Toggle initial setzen
		//    – Wenn High-Contrast aktiv: Theme erzwingen auf Light
		var initialTheme = savedContrast ? 'light' : savedTheme;
		$themeBtn
			.removeClass('light-active dark-active')
			.addClass(initialTheme === 'dark' ? 'dark-active' : 'light-active');
		$body
			.removeClass('theme-mode-light theme-mode-dark')
			.addClass('theme-mode-' + initialTheme);

		// 3) Contrast-Toggle initial setzen
		if (savedContrast) {
			$contrastBtn
				.removeClass('site-contrast-normal')
				.addClass('site-contrast-high')
				.attr('aria-pressed', 'true');
			$body
				.addClass('contrast-high-mode')
				.removeClass('theme-mode-dark');
			// High-Contrast erfordert immer Light-Theme
			localStorage.setItem('theme', 'light');
		}

		// 4) Klick-Handler für Light/Dark-Mode
		$themeBtn.on('click', function() {
			var isNowDark = $themeBtn.toggleClass('light-active dark-active')
				.hasClass('dark-active');

			// Body umschalten und speichern
			$body.toggleClass('theme-mode-light theme-mode-dark');
			localStorage.setItem('theme', isNowDark ? 'dark' : 'light');

			// Wenn wir auf Dark wechseln: High-Contrast abschalten
			if (isNowDark && localStorage.getItem('highContrast') === 'true') {
				$contrastBtn
					.removeClass('site-contrast-high')
					.addClass('site-contrast-normal')
					.attr('aria-pressed', 'false');
				$body.removeClass('contrast-high-mode');
				localStorage.setItem('highContrast', 'false');
			}
		});

		// 5) Klick-Handler für High-Contrast
		$contrastBtn.on('click', function() {
			var turnOn = $contrastBtn.hasClass('site-contrast-normal');

			if (turnOn) {
				// — High-Contrast einschalten
				$contrastBtn
					.removeClass('site-contrast-normal')
					.addClass('site-contrast-high')
					.attr('aria-pressed', 'true');

				// Body anpassen: immer Light-Theme + High-Contrast
				$body
					.addClass('contrast-high-mode')
					.removeClass('theme-mode-dark')
					.addClass('theme-mode-light');

				// Theme-Toggle auf Light setzen
				$themeBtn
					.removeClass('dark-active')
					.addClass('light-active');

				// Speichern
				localStorage.setItem('highContrast', 'true');
				localStorage.setItem('theme', 'light');

			} else {
				// — High-Contrast ausschalten
				$contrastBtn
					.removeClass('site-contrast-high')
					.addClass('site-contrast-normal')
					.attr('aria-pressed', 'false');

				// Body zurücksetzen, Theme bleibt wie zuvor (im LS)
				$body.removeClass('contrast-high-mode');

				localStorage.setItem('highContrast', 'false');
			}
		});
	});



	//--------------------------------------------------------------------------------
	// main nav

	// cache selectors
	var $body = $('body');
	var $primary_nav_menusContainer = $('#primary-navigation .menus');
	var $primary_menu_subMenus = $('#primary-menu .sub-menu'); // Selector for primary sub-menus
	var $primary_menu_toggleLinks = $('#primary-menu .menu-item-has-children > a'); // Selector for primary toggle links
	var $secondary_menu_subMenus = $('#secondary-menu .sub-menu');
	var $secondary_menu_toggleLinks = $('#secondary-menu .menu-item-has-children > a');


	// MOBILE NAV HEIGHT HELPER --------------------------------------------
	function mobile_nav_height_helper() {
		// remove inline heights so we measure natural heights
		$primary_nav_menusContainer
			.add($secondary_menu_subMenus)
			.add($primary_menu_subMenus) // Include primary sub-menus for height reset
			.removeAttr('style');

		// only run in mobile mode
		if (!$body.hasClass('mobile')) {
			return;
		}

		// measure the height of the first-level menus
		var baseHeight = $primary_nav_menusContainer.outerHeight(true);
		var maxHeight = baseHeight;

		// find the tallest sub-menu from both primary and secondary menus
		$secondary_menu_subMenus.add($primary_menu_subMenus).each(function() {
			var h = $(this).outerHeight();
			if (h > maxHeight) {
				maxHeight = h;
			}
		});

		// apply the tallest height to container and all sub-menus
		$primary_nav_menusContainer.css('height', maxHeight);
		$secondary_menu_subMenus.add($primary_menu_subMenus).css('height', maxHeight);
	}


	// TABLET NAV HEIGHT HELPER --------------------------------------------
	function tablet_nav_height_helper() {
		var $body_element = $('body');
		var $primary_nav_menus_container = $('#primary-nav-menus-container');
		var $primary_menu_sub_menus = $primary_nav_menus_container.find('#primary-menu .sub-menu'); // Local selector for primary sub-menus
		var $secondary_menu_sub_menus = $primary_nav_menus_container.find('#secondary-menu .sub-menu'); // Consistent selector for secondary
		var $primary_menu = $primary_nav_menus_container.find('#primary-menu');
		var $secondary_menu = $primary_nav_menus_container.find('#secondary-menu');

		// Inline-Styles zurücksetzen
		$primary_nav_menus_container
			.add($secondary_menu_sub_menus)
			.add($primary_menu_sub_menus) // Include primary sub-menus
			.removeAttr('style');

		if (!$body_element.hasClass('tablet')) {
			return;
		}

		// sichere Funktion: prüft existence und gibt 0 zurück, wenn nichts gefunden
		function getFullHeight($el) {
			if (!$el || !$el.length) {
				// console.warn('getFullHeight: Element nicht gefunden', $el);
				return 0;
			}
			return $el[0].scrollHeight;
		}

		// Werte holen
		var primary_menu_height = getFullHeight($primary_menu);
		var secondary_menu_height = getFullHeight($secondary_menu);

		// console.log('Primary:', primary_menu_height, 'Secondary:', secondary_menu_height);

		// Max der ersten Ebene
		var max_first_level = Math.max(primary_menu_height, secondary_menu_height);

		// Höchstes Sub-Menü
		var overall_max = max_first_level;
		$secondary_menu_sub_menus.add($primary_menu_sub_menus).each(function() { // Check all sub-menus
			var h = this.scrollHeight;
			if (h > overall_max) overall_max = h;
		});

		// console.log('Gesamt-Maximalhöhe:', overall_max);

		// Höhe setzen
		$primary_nav_menus_container.css('height', overall_max + 'px');
		$secondary_menu_sub_menus.add($primary_menu_sub_menus).css('height', overall_max + 'px'); // Apply height to all sub-menus
	}



	// INITIALIZE AND RESIZE HANDLERS ---------------------------------------
	mobile_nav_height_helper();
	tablet_nav_height_helper();

	$(window).on('resize', function() {
		classMobile();
		mobile_nav_height_helper();
		tablet_nav_height_helper();
		tableFixedColumn();
	});


	// NAV MENU OPEN / CLOSE -----------------------------------------------
	$(document).on('click', '#nav-menu-button', function() {
		var $btn = $(this);

		// toggle classes for menu state
		$btn.toggleClass('is-open is-closed');
		$body.toggleClass('bodyfix');
		$('.hamburger').toggleClass('is-active');
		$btn.toggleClass('is-active');
		$('#nav-dialog').toggleClass('is-open');

		// add blur effect after opening
		setTimeout(function() {
			$('#nav-dialog').addClass('blur');
		}, 500);

		// update ARIA attributes on button
		toggleAttr($btn, 'aria-expanded', 'true', 'false');
		toggleAttr($btn, 'aria-pressed', 'true', 'false');
	});

	function close_nav_dialog() {
		// remove blur immediately
		$('#nav-dialog').removeClass('blur');

		setTimeout(function() {
			// reset body and button classes
			$body.removeClass('bodyfix');
			$('.hamburger').removeClass('is-active');
			$('#nav-menu-button')
				.removeClass('is-active is-open')
				.addClass('is-closed');
			$('#nav-dialog')
				.removeClass('is-open')
				.attr('aria-hidden', 'true');

			// update ARIA on toggle button
			toggleAttr($('#nav-menu-button'), 'aria-expanded', 'true', 'false');
			toggleAttr($('#nav-menu-button'), 'aria-pressed', 'true', 'false');

			// close any open sub-menus after dialog closes
			setTimeout(function() {
				$secondary_menu_subMenus
					.add($primary_menu_subMenus) // Also close primary sub-menus
					.filter('.is-open')
					.each(function() {
						var $sub = $(this);
						$sub.removeClass('is-open').attr('aria-hidden', 'true');
						$sub.prev('a').attr('aria-expanded', 'false');
					});
			}, 350);

		}, 250);
	}

	$(document).on('click', '#close-nav-dialog', close_nav_dialog);

	// close on ecs key
	$(document).on('keyup', function(e) {
		if (e.which === 27) {
			close_nav_dialog();
		}
	});




	// SUB-MENU TOGGLE HANDLER FOR MOBILE & TABLET --------------------------
	// Set initial accessibility attributes for all toggle links and sub-menus
	$primary_menu_toggleLinks.add($secondary_menu_toggleLinks).attr('aria-expanded', 'false');
	$primary_menu_subMenus.add($secondary_menu_subMenus).attr('aria-hidden', 'true');

	// Attach click handler to all toggle links
	$primary_menu_toggleLinks.add($secondary_menu_toggleLinks).on('click', function(e) {
		// only toggle in mobile or tablet
		if (!$body.hasClass('mobile') && !$body.hasClass('tablet')) {
			// if desktop, ensure all are closed
			$secondary_menu_subMenus
				.add($primary_menu_subMenus)
				.removeClass('is-open')
				.attr('aria-hidden', 'true');
			$secondary_menu_toggleLinks
				.add($primary_menu_toggleLinks)
				.removeClass('is-open')
				.attr('aria-expanded', 'false');
			return;
		}

		e.preventDefault();

		var $link = $(this);
		var $submenu = $link.next('.sub-menu');

		// close all other sub-menus in both menus
		$secondary_menu_subMenus
			.add($primary_menu_subMenus)
			.not($submenu)
			.removeClass('is-open')
			.attr('aria-hidden', 'true');
		$secondary_menu_toggleLinks
			.add($primary_menu_toggleLinks)
			.not($link)
			.removeClass('is-open')
			.attr('aria-expanded', 'false');

		// determine new open state
		var willOpen = !$submenu.hasClass('is-open');

		// toggle classes and ARIA on clicked item
		$submenu
			.toggleClass('is-open', willOpen)
			.attr('aria-hidden', willOpen ? 'false' : 'true');
		$link
			.toggleClass('is-open', willOpen)
			.attr('aria-expanded', willOpen ? 'true' : 'false');

		// recalculate heights
		if ($body.hasClass('mobile')) {
			mobile_nav_height_helper();
		}
		if ($body.hasClass('tablet')) {
			tablet_nav_height_helper();
		}
	});


	// close sub-menu via “back” button, update classes/ARIA and recalc height
	// Attach handler to both primary and secondary menus
	$('#primary-menu, #secondary-menu').on('click touchstart', '.sub-menu .back', function(e) {
		// only in mobile or tablet mode
		if (!$body.hasClass('mobile') && !$body.hasClass('tablet')) {
			return;
		}

		e.preventDefault();

		var $submenu = $(this).closest('.sub-menu');
		var $toggle = $submenu.prev('a');

		// remove open state on submenu
		$submenu
			.removeClass('is-open')
			.attr('aria-hidden', 'true');

		// remove open state on its toggle link
		$toggle
			.removeClass('is-open')
			.attr('aria-expanded', 'false');

		// recalculate wrapper + submenu heights
		if ($body.hasClass('mobile')) {
			mobile_nav_height_helper();
		} else {
			tablet_nav_height_helper();
		}
	});





	// sticky nav --------------------------------------------------

	const target = $('body');
	const min_save_zone = 50;
	const save_zone_vh = 30;

	let vh = viewportHeight();
	let safe_zone = Math.max(vh * save_zone_vh, min_save_zone);

	$(window).on('resize', (function() {
		let timer = null;
		return function() {
			clearTimeout(timer);
			timer = setTimeout(function() {
				vh = viewportHeight();
				safe_zone = Math.max(vh * save_zone_vh, min_save_zone);
			}, 500);
		};
	})());

	let lastScrollTop = 0;

	function stickyClasses() {
		var currentScroll = $(window).scrollTop();
		if (currentScroll < safe_zone) {
			target.removeClass('sticky scroll-up scroll-down').addClass('scroll-top');
		} else {
			target.addClass('sticky');
			if (currentScroll > lastScrollTop) {
				target.removeClass('scroll-up').addClass('scroll-down');
			} else {
				target.removeClass('scroll-down').addClass('scroll-up').removeClass('scroll-top');
			}
		}
		lastScrollTop = currentScroll;
	}

	$(window).scroll(function() {
		stickyClasses();
	});


	// accessibility dialog ---------------------------------------------------------------------------

	$(document).on('click', '#accessibility-dialog-button', function() {
		var $btn = $(this);

		$btn.toggleClass('is-open is-closed');
		$('#accessibility-dialog').toggleClass('is-open');
		// update ARIA attributes on button
		toggleAttr($btn, 'aria-expanded', 'true', 'false');
		toggleAttr($btn, 'aria-pressed', 'true', 'false');
	});

	function close_accessibility_dialog() {
		// remove blur immediately
		// $('#nav-dialog').removeClass('blur');

		$('#accessibility-dialog-button')
			.removeClass('is-active is-open')
			.addClass('is-closed');
		$('#accessibility-dialog')
			.removeClass('is-open')
			.attr('aria-hidden', 'true');

		// update ARIA on toggle button
		toggleAttr($('#accessibility-dialog-button'), 'aria-expanded', 'true', 'false');
		toggleAttr($('#accessibility-dialog-button'), 'aria-pressed', 'true', 'false');
	}

	$(document).on('click', '#close-accessibility-dialog', close_accessibility_dialog);

	// close on ecs key
	$(document).on('keyup', function(e) {
		if (e.which === 27) {
			close_accessibility_dialog();
		}
	});

	// close on click outside
	$(document).on('click', '#accessibility-dialog', function(e) {
		if (!$(e.target).closest('.dialog-wrapper').length) {
			close_accessibility_dialog();
		}
	});





	// flex anchor nav -----------------------------------------------------------------------
	// Select the navigation links and their corresponding anchor sections.
	var anchor_nav_links = $('.anchor-menu ul li a');
	var anchor_sections = $('.flex-anchor[id]');

	// Only execute the scroll-spy logic if both navigation and section elements exist on the page.
	if (anchor_nav_links.length > 0 && anchor_sections.length > 0) {

		/**
		 * Updates the 'is-active' class on anchor navigation links based on the current scroll position.
		 */
		var set_active_anchor_link = function() {
			// Define a vertical offset to activate the link slightly before the section hits the top.
			var scroll_offset = 150;
			var scroll_position = $(window).scrollTop() + scroll_offset;
			var active_section_id = null;

			// Iterate over each section to determine which is currently in the viewport.
			anchor_sections.each(function() {
				var current_section = $(this);
				// Ensure the section is visible before calculating its position.
				if (current_section.is(':visible')) {
					var section_top = current_section.offset().top;
					// If the user has scrolled past the top of this section, mark it as potentially active.
					if (section_top <= scroll_position) {
						active_section_id = current_section.attr('id');
					}
				}
			});

			// If no section is considered active (e.g., at the very top), default to the first one.
			if (active_section_id === null) {
				active_section_id = anchor_sections.first().attr('id');
			}

			// Apply the 'is-active' class to the corresponding navigation link.
			anchor_nav_links.each(function() {
				var nav_link = $(this);
				var list_item = nav_link.parent();
				var href = nav_link.attr('href');

				// Check if the link's href matches the active section's ID.
				if (href && href.substring(1) === active_section_id) {
					list_item.addClass('is-active');
				} else {
					list_item.removeClass('is-active');
				}
			});
		};

		// Attach the function to the window's scroll and load events.
		$(window).on('scroll', set_active_anchor_link);
		$(window).on('load', set_active_anchor_link);

	}

	// ------------------------------------------------------------------------------------------------
	// Sticky anchor menu for in-page positions (after_hero, before_flex_content)
	// ------------------------------------------------------------------------------------------------

	var $anchor_menu = $('.anchor-menu');
	var $body = $('body');
	var is_in_page = $body.hasClass('has-page-anchors-after-hero') || $body.hasClass('has-page-anchors-before-flex-content');

	if ($anchor_menu.length > 0 && is_in_page) {
		var anchor_menu_original_offset = null;
		var header_bar_height = 0;
		var anchor_menu_height = 0;
		var $placeholder = null;

		// Get the original offset position
		function init_anchor_menu_sticky() {
			if ($anchor_menu.length > 0) {
				// Get header bar height from CSS variable
				var computed_header_height = getComputedStyle(document.documentElement).getPropertyValue('--header-bar-height');
				header_bar_height = computed_header_height ? parseFloat(computed_header_height) : 60;

				// Get anchor menu height
				anchor_menu_height = $anchor_menu.outerHeight();

				// Get the original offset of the anchor menu
				if (!$anchor_menu.hasClass('is-stuck')) {
					anchor_menu_original_offset = $anchor_menu.offset().top;
				}

				// Create placeholder to prevent layout shift
				if (!$placeholder) {
					$placeholder = $('<div class="anchor-menu-placeholder"></div>');
					$placeholder.css({
						'height': anchor_menu_height + 'px',
						'display': 'none'
					});
					$anchor_menu.after($placeholder);
				} else {
					// Update placeholder height
					$placeholder.css('height', anchor_menu_height + 'px');
				}
			}
		}

		// Track when menu is stuck (for applying hide/show transforms)
		function handle_anchor_menu_stuck() {
			if (!anchor_menu_original_offset) return;

			var scroll_top = $(window).scrollTop();
			var is_stuck = scroll_top >= (anchor_menu_original_offset - header_bar_height);

			// Add class when stuck and show placeholder to prevent layout shift
			if (is_stuck) {
				if (!$anchor_menu.hasClass('is-stuck')) {
					$anchor_menu.addClass('is-stuck');
					$placeholder.css('display', 'block');
				}
			} else {
				if ($anchor_menu.hasClass('is-stuck')) {
					$anchor_menu.removeClass('is-stuck');
					$placeholder.css('display', 'none');
				}
			}
		}

		// Initialize on load
		$(window).on('load', function() {
			init_anchor_menu_sticky();
			handle_anchor_menu_stuck();
		});

		// Recalculate on resize
		$(window).on('resize', (function() {
			var timer = null;
			return function() {
				clearTimeout(timer);
				timer = setTimeout(function() {
					// Temporarily remove stuck state to recalculate
					var was_stuck = $anchor_menu.hasClass('is-stuck');
					if (was_stuck) {
						$anchor_menu.removeClass('is-stuck');
						$placeholder.css('display', 'none');
					}
					init_anchor_menu_sticky();
					handle_anchor_menu_stuck();
				}, 500);
			};
		})());

		// Handle on scroll
		$(window).on('scroll', function() {
			handle_anchor_menu_stuck();
		});
	}

	// ------------------------------------------------------------------------------------------------
	// image parallax 
	/**
	 * Applies a parallax effect to an element.
	 * @param {HTMLElement} element - The DOM element representing the parallax container.
	 * @param {number} scrollTop - The current scroll position of the window.
	 * @param {number} windowHeight - The height of the window.
	 * @param {number} [factor=0.2] - The factor for the effect's strength.
	 */
	function applyParallax(element, scrollTop, windowHeight, factor = 0.5) {
		const $el = $(element);
		const elOffset = $el.offset().top;
		const elHeight = $el.height();

		if (scrollTop + windowHeight > elOffset && scrollTop < elOffset + elHeight) {
			const scrollRelative = scrollTop - elOffset;
			$el.find('figure').css({
				'transform': 'translateY(' + scrollRelative * factor + 'px)'
			});
		}
	}


	$(window).on('scroll', function() {
		const scrollTop = $(this).scrollTop();
		const windowHeight = $(this).height();

		$('.image-parallax').each(function() {
			applyParallax(this, scrollTop, windowHeight);
		});
	});

	// ------------------------------------------------------------------------------------------------


	// =========================================================================
	// == START: YOUTUBE PLAYER CONTROL (FINAL VERSION)
	// =========================================================================

	let ytPlayers = {};
	let ytPlayerInitializationQueue = [];
	// We don't need the isYtApiReady flag anymore, the new logic handles it.

	/**
	 * THIS IS THE KEY CHANGE.
	 * By attaching the function to `window`, we make it globally accessible,
	 * ensuring the YouTube API script can find and call it.
	 */
	window.onYouTubeIframeAPIReady = function() {
		// Process any dialogs that were opened before the API was ready.
		ytPlayerInitializationQueue.forEach(createPlayerForDialog);

		// Clear the queue after processing.
		ytPlayerInitializationQueue = [];
	};

	function createPlayerForDialog($dialog) {
		const dialogId = $dialog.attr('id');

		// Immediately return if a player for this dialog already exists.
		if (ytPlayers[dialogId]) {
			// If it exists, just try to play it.
			const player = ytPlayers[dialogId];
			if (player && typeof player.playVideo === 'function') {
				player.playVideo();
			}
			return;
		}

		const $playerDiv = $dialog.find('.player[data-youtube-video-id]');
		const playerElement = $playerDiv[0];
		const videoId = $playerDiv.data('youtube-video-id');

		if (videoId && playerElement) {
			// console.log("Creating player for Video ID '" + videoId + "' in dialog '" + dialogId + "'.");

			const player = new YT.Player(playerElement, {
				height: '100%',
				width: '100%',
				videoId: videoId,
				playerVars: {
					'playsinline': 1,
					'rel': 0,
					'autoplay': 1,
					'loop': 0,
					'playlist': videoId
				},
				events: {
					'onReady': function(event) {
						// Autoplay is now handled by playerVars, but we can still log.
					},
					'onError': function(event) {
						// console.error("❌ YouTube Player Error for " + dialogId + ": ", event.data);
					}
				}
			});

			ytPlayers[dialogId] = player;
		}
	}




	// ─────────────── Helper Functions ───────────────

	// Starts all local (MediaElement.js/html5) videos inside a dialog
	function start_wp_video($dialog) {
		$dialog.find('.local video').each(function() {
			var vid = this;
			// If WordPress attached a MediaElementPlayer instance
			if (vid.player && typeof vid.player.play === 'function') {
				vid.player.play();
			}
			// Fallback to the global mejs.players collection
			else if (window.mejs && mejs.players && mejs.players[vid.id]) {
				mejs.players[vid.id].play();
			}
			// Final fallback to the native HTML5 API
			else {
				vid.play();
			}
		});
	}

	// Pauses and rewinds all local videos inside a dialog
	function stop_wp_video($dialog) {
		$dialog.find('.local video').each(function() {
			var vid = this;
			if (vid.player && typeof vid.player.pause === 'function') {
				vid.player.pause();
			} else if (window.mejs && mejs.players && mejs.players[vid.id]) {
				mejs.players[vid.id].pause();
			} else {
				vid.pause();
			}
			// Rewind to start
			vid.currentTime = 0;
		});
	}

	// Starts the YouTube iframe player in the given dialog
	function startYouTubeVideo($dialog) {
		var dialogId = $dialog.attr('id');
		var ytPlayer = ytPlayers[dialogId];
		if (ytPlayer && typeof ytPlayer.playVideo === 'function') {
			ytPlayer.playVideo();
		}
	}

	// Stops (and rewinds) all YouTube players on the page
	function stopAllYouTubeVideos() {
		for (var id in ytPlayers) {
			var ytPlayer = ytPlayers[id];
			if (ytPlayer && typeof ytPlayer.stopVideo === 'function') {
				ytPlayer.stopVideo(); // automatically resets to 0
				// optionally force seek: ytPlayer.seekTo(0);
			}
		}
	}


	/**
	 * Finds the iframe within the .spotify container and fades the container in when ready.
	 * @param {jQuery} $dialog The dialog element containing the player.
	 */
	function startSpotifyPlayer($dialog) {
		// Find the container which now has both classes.
		var $container = $dialog.find('.lightbox-content.spotify');

		if ($container.length) {
			var $iframe = $container.find('iframe');

			// Attach a 'load' event listener to the iframe.
			$iframe.off('load').on('load', function() {
				// When the iframe is ready, fade in its container.
				$container.fadeTo('fast', 1);
			});

			// Get the original source URL.
			var originalSrc = $iframe.data('original-src');
			if (!originalSrc) {
				originalSrc = $iframe.attr('src');
				if (!originalSrc) return;
				$iframe.data('original-src', originalSrc);
			}

			// Set the src to trigger the loading process.
			$iframe.attr('src', originalSrc);
		}
	}
	/**
	 * Stops all Spotify players on the page.
	 * It does this by clearing the iframe's src attribute.
	 */
	function stopAllSpotifyPlayers() {
		$('dialog.lightbox .player.spotify iframe, dialog.lightbox .lightbox-content.spotify iframe').each(function() {
			var $iframe = $(this);
			if (!$iframe.data('original-src')) {
				$iframe.data('original-src', $iframe.attr('src'));
			}
			// Stop playback.
			$iframe.attr('src', '');
		});
	}

	// lightbox function
	$(document).on('click', '.lightbox-button', function(e) {
		e.stopPropagation();
		e.preventDefault();

		var $btn = $(this);
		var selector = '#' + $btn.attr('aria-controls');
		var $dialog = $(selector);

		// Enqueue YouTube init, if needed
		ytPlayerInitializationQueue.push($dialog);
		if (window.YT && window.YT.Player) {
			onYouTubeIframeAPIReady();
		}

		$('body').toggleClass('bodyfix');
		$btn.toggleClass('is-open');
		toggleAttr($dialog, 'hidden', 'hidden', null);

		setTimeout(function() {
			$dialog.addClass('is-open');

			// =========================================================================
			// == START: MODIFIKATION FÜR REAL COOKIE BANNER
			// =========================================================================
			var isYouTube = $dialog.find('.player[data-youtube-video-id]').length > 0;
			var isSpotify = $dialog.find('.lightbox-content.spotify').length > 0;

			var hasYouTubeConsent = $('body').hasClass('real-cookie-banner-allowed-service-youtube');
			var hasSpotifyConsent = $('body').hasClass('real-cookie-banner-allowed-service-spotify');

			// Wenn für YouTube oder Spotify keine Zustimmung erteilt wurde,
			// die Opacity des Inhalts direkt auf 1 setzen,
			// damit der Platzhalter des Cookie-Banners sichtbar ist.
			if ((isYouTube && !hasYouTubeConsent) || (isSpotify && !hasSpotifyConsent)) {
				$dialog.find('.lightbox-content').css('opacity', 1);
			}
			// =========================================================================
			// == END: MODIFIKATION
			// =========================================================================

			// START all local & YouTube videos
			start_wp_video($dialog);
			startYouTubeVideo($dialog);
			startSpotifyPlayer($dialog);
		}, 500);
	});


	function closeLightboxes() {
		// STOP all players
		stopAllYouTubeVideos();
		stopAllSpotifyPlayers();

		// PAUSE all local videos
		$('dialog.lightbox').each(function() {
			stop_wp_video($(this));
		});

		// Close UI state - This starts the closing animation
		$('dialog.lightbox').removeClass('is-open');
		$('body').removeClass('bodyfix');
		$('.lightbox-button').attr('aria-expanded', false).blur();
		$('dialog.lightbox').find('.cycle-slideshow').cycle('stop');

		// This block runs AFTER the 500ms closing animation is complete
		setTimeout(function() {
			// Reset the Spotify container's opacity HERE.
			// At this point, the dialog is invisible, so there is no conflict.
			$('dialog.lightbox .lightbox-content.spotify').css('opacity', 0);

			$('dialog.lightbox').prop('hidden', true);

			// Now, fully hide the dialog from the DOM			$('dialog.lightbox').prop('hidden', true);
			$('.lightbox-button').delay(500).removeClass('is-open');
		}, 500);
	}

	$(document).on('click', '.lightbox-close-button', function() {
		closeLightboxes();
	});

	$(document).on('click', 'dialog.lightbox', function(e) {
		if (!$(e.target).closest('.lightbox-content').length) {
			closeLightboxes();
		}
	});

	$(document).on('keyup', function(e) {
		if (e.which === 27) {
			closeLightboxes();
		}
	});


	// -------------------------------------------
	// caption 

	$('figcaption[hidden]').hide();

	$(document).on('click', '.caption-button', function() {
		let $caption_button = $(this);
		let $caption_content = $caption_button.next('figcaption');

		$caption_button.toggleClass('is-open');
		toggleAttr($caption_button, 'aria-expanded', 'true', 'false');

		$caption_content.delay(200).fadeToggle(300);

	});



	// initially hide all toggle content and remove 'hidden' attribute for accessibility
	$('.toggle-content').hide().removeAttr('hidden');

	$(document).on('click', '.toggle-button', function() {
		const $btn = $(this);
		const $anchor_section = $btn.closest('.toggle-section');
		const $content = $anchor_section.children('.toggle-content');
		const wasOpen = $btn.hasClass('is-open');

		// Use the greater of 100px or 5vh of the viewport height as scroll gap
		const scrollGap = Math.max(viewportHeight(5), 100);
		const duration = 500;
		const easing = 'easeOutQuint';

		$btn.toggleClass('is-open');
		toggleAttr($btn, 'aria-expanded', 'true', 'false');

		if (wasOpen) {
			// If closing: calculate scroll target including upper gap
			let targetTop = Math.max(0, $anchor_section.offset().top - scrollGap);

			// Smoothly slide up the content and scroll simultaneously
			$content
				.stop(true) // cancel any ongoing animation on this element
				.slideUp({ duration, queue: false, easing });

			$('html, body')
				.stop(true) // stop other scrolling animations
				.animate({ scrollTop: targetTop }, { duration, queue: false, easing });
		} else {
			// if opening just slide down
			$content
				.stop(true)
				.slideDown({
					duration,
					easing,
					complete: function() {


						// $content[0].offsetHeight;
						tableFixedColumn();

					}
				});
		}
	});

	//--------------------------------------------------------------------------------------------------
	// anchor_section tabs: text-tabs-chronicle

	$('.section-tabs').on('click', '.tab-button', function() {
		console.log('click section-tabs');

		var element_id = $(this).attr("aria-controls"); // Die ID aus aria-controls holen

		$(this).toggleClass('is-open is-closed');
		$(this).siblings().removeClass('is-open').addClass('is-closed');
		//var siblings = tab_content.siblings(); // Alle Geschwister-Elemente holen
		$("#" + element_id).siblings().attr('hidden', true);

		//siblings.attr('hidden', true);
		$("#" + element_id).attr('hidden', false);
	});

	//	pill tabs
	$('.pill-tabs').each(function() {
		const $tabs_module = $(this);
		const $tabsContainer = $tabs_module.find('.tabs');
		const $tabs = $tabsContainer.find('.tab-button');
		const $indicator = $tabsContainer.find('.indicator');

		if ($tabsContainer.length === 0) {
			return; // Entspricht einem 'continue' in einer .each() Schleife
		}

		let active_index = $tabs.index($tabs.filter('.is-open'));

		function checkOverflow() {
			const el = $tabsContainer.get(0);
			const isOverflowing = el.scrollWidth > el.clientWidth;
			// We need has-overflow to be set for our click handler
			$tabsContainer.toggleClass('has-overflow', isOverflowing);

			const hasOverflowLeft = el.scrollLeft > 1;
			const hasOverflowRight = Math.ceil(el.scrollLeft) < el.scrollWidth - el.clientWidth - 1;
			$tabsContainer.toggleClass('overflow-left', hasOverflowLeft).toggleClass('overflow-right', hasOverflowRight);
		}

		if (active_index < 0) active_index = 0;

		function activateTab(index, isInitial) {
			const $tab = $tabs.eq(index);
			if (!$tab.length) return;

			const visiblePosition = $tab.offset().left - $tabsContainer.offset().left;
			const truePosition = visiblePosition + $tabsContainer.scrollLeft();

			const indicatorTransition = isInitial ? 'none' : '';

			$indicator.css({
				'transition': indicatorTransition,
				'left': truePosition,
				'width': $tab.outerWidth()
			});

			$tabs.removeClass('is-open').attr('aria-expanded', 'false');
			$tab.addClass('is-open').attr('aria-expanded', 'true');

			const $contentWrapper = $tabs_module.find('.tab-content');
			const $contentItems = $contentWrapper.children('.tab-item');
			$contentItems.removeClass('is-open').prop('hidden', true);
			const id = $tab.attr('aria-controls');
			$contentWrapper.find('#' + id).addClass('is-open').prop('hidden', false);

			active_index = index;
		}

		$tabs.on('click', function() {

			const $clickedTab = $(this);
			const index = $tabs.index($clickedTab);

			if (index !== active_index) {

				// --- FINAL FIX: Check if the container is actually scrollable ---
				if ($tabsContainer.hasClass('has-overflow')) {
					// If it has overflow, run the scroll animation
					const containerWidth = $tabsContainer.width();
					const tabWidth = $clickedTab.outerWidth();
					const visiblePos = $clickedTab.offset().left - $tabsContainer.offset().left;
					const truePos = visiblePos + $tabsContainer.scrollLeft();
					const targetScrollLeft = truePos - (containerWidth / 2) + (tabWidth / 2);

					$tabsContainer.animate({
						scrollLeft: targetScrollLeft
					}, 350, function() {
						// Update indicator after the scroll is complete
						activateTab(index);
					});

				} else {
					// If no overflow, just activate the tab directly
					activateTab(index);
				}
			}
		});

		// Initial setup
		activateTab(active_index, true);
		checkOverflow();

		$tabsContainer.on('scroll', checkOverflow);

		let resizeTimer;
		$(window).on('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				// We need to check overflow first to see if a scrollbar appeared/disappeared
				checkOverflow();
				activateTab(active_index, true);
			}, 250);
		});
	});




	//--------------------------------------------------------------------------------------------------
	// slider content 
	$('.slider-content').each(function() {
		const $slider = $(this);
		const $module = $slider.find('.slider-module');
		const $pagerButtons = $slider.find('.pager .pager-button');
		const $slideWrapper = $slider.find('.slides');
		const $slideItems = $slideWrapper.find('.item');
		let activeIndex = $pagerButtons.index($pagerButtons.filter('.active'));


		// Fallback: activate first slide if none is active
		if (activeIndex < 0) {
			activeIndex = 0;
			$pagerButtons.eq(0)
				.addClass('active')
				.attr('aria-expanded', 'true');
		}

		// Setup fade duration and pause time from data attribute (in seconds)
		const fadeTime = 800;
		const pauseSeconds = parseFloat($module.attr('data-slider-pause-time')) || 5;
		const pauseTime = pauseSeconds * 1000;
		let autoplayTimer;
		let pausedByCaption = false;

		// Prepare slides: remove hidden attribute, hide all, show current active
		$slideItems
			.removeAttr('hidden')
			.hide()
			.eq(activeIndex)
			.show();

		// Helper: closes all open captions
		function closeOpenCaptions() {
			$slider.find('.caption-button.is-open').each(function() {
				const $btn = $(this);
				const $content = $btn.next('figcaption');
				$btn.removeClass('is-open');
				toggleAttr($btn, 'aria-expanded', 'true', 'false');
				$content.stop(true, true).fadeOut(300);
			});
		}

		// Switch to specific slide with fade transition
		function activateSlide(newIndex) {
			if (newIndex === activeIndex) return;

			$pagerButtons
				.removeClass('active')
				.attr('aria-expanded', 'false')
				.eq(newIndex)
				.addClass('active')
				.attr('aria-expanded', 'true');

			$slideItems.eq(activeIndex)
				.stop(true, true)
				.fadeOut(fadeTime);
			$slideItems.eq(newIndex)
				.stop(true, true)
				.fadeIn(fadeTime);

			activeIndex = newIndex;
		}

		// Start autoplay loop (if not paused by open caption unless overridden)
		function startAutoplay(override = false) {
			if (pausedByCaption && !override) return;
			clearInterval(autoplayTimer);
			autoplayTimer = setInterval(() => {
				const next = activeIndex < $slideItems.length - 1 ? activeIndex + 1 : 0;
				activateSlide(next);
			}, pauseTime + fadeTime);
		}

		// Stop autoplay
		function stopAutoplay() {
			clearInterval(autoplayTimer);
		}

		// Manual pager button click: closes caption, triggers slide change, resumes autoplay
		$pagerButtons.on('click', function() {
			closeOpenCaptions();
			const idx = $pagerButtons.index(this);
			activateSlide(idx);
			pausedByCaption = false;
			startAutoplay(true);
		});

		// Caption button click: pauses/resumes autoplay depending on open state
		$slider.on('click', '.caption-button', function() {
			setTimeout(() => {
				const $btn = $(this);
				const isOpen = $btn.hasClass('is-open') &&
					$btn.attr('aria-expanded') === 'true';
				if (isOpen) {
					pausedByCaption = true;
					stopAutoplay();
				} else {
					pausedByCaption = false;
					startAutoplay(true);
				}
			}, 0);
		});

		// Pause autoplay on hover
		$slider.on('mouseenter', stopAutoplay);
		$slider.on('mouseleave', () => startAutoplay());

		// Handle swipe gestures for slide navigation
		let touchStartX = 0;
		let touchStartY = 0;
		let isSwiping = false;

		$slideWrapper.on('touchstart', function(e) {
			// Ignore swipe if caption or copyright button is touched
			if ($(e.target).closest('.caption-button, .copyright-button').length) return;
			const t = e.originalEvent.touches[0];
			touchStartX = t.pageX;
			touchStartY = t.pageY;
			isSwiping = true;
		});

		$slideWrapper.on('touchmove', function(e) {
			if (!isSwiping) return;
			const t = e.originalEvent.touches[0];
			if (Math.abs(t.pageY - touchStartY) > Math.abs(t.pageX - touchStartX)) {
				isSwiping = false; // Abort swipe if vertical movement is stronger
			}
		});

		$slideWrapper.on('touchend', function(e) {
			if (!isSwiping) return;
			closeOpenCaptions();

			const t = e.originalEvent.changedTouches[0];
			const dx = t.pageX - touchStartX;
			const threshold = 50;
			if (Math.abs(dx) > threshold) {
				const next = dx < 0 ?
					(activeIndex < $slideItems.length - 1 ? activeIndex + 1 : 0) :
					(activeIndex > 0 ? activeIndex - 1 : $slideItems.length - 1);
				activateSlide(next);
			}
			isSwiping = false;
		});

		// start off autoplay
		startAutoplay();
	});









	//--------------------------------------------------------------------------------------------------
	// overflow scroll (tab tags… )	 

	$(window).on('load', function() {

		$('.overflow-scroll').each(function() {

			// Define a constant for the current .overflow-scroll element to add/remove a class.
			const $overflowScroll = $(this);
			// Find necessary elements within the current component.
			const $container = $(this).find('.panel'); // The scrollable container.

			if ($container.length === 0) {
				return;
			}

			const $scrollLeft = $(this).find('.prev'); // The left scroll button.
			const $scrollRight = $(this).find('.next'); // The right scroll button.
			const $prefNext = $(this).find('.prev-next'); // The container for both scroll buttons.
			const $items = $container.find('.item'); // The items within the scrollable container.

			// A flag to prevent multiple scroll animations from running at the same time.
			let animating = false;
			// The width of a single item, used for calculating scroll distance.
			let itemWidth = $items.outerWidth(); // without margin
			// The gap between items, also used for calculating scroll distance.
			let gapValue = 0; // Variable to store the gap value

			// This function checks the scroll state, adds/removes the .has-overflow class, and updates the navigation buttons.
			function updateButtons() {
				itemWidth = $items.outerWidth();
				gapValue = parseFloat($container.css('column-gap')) || 0;
				const scrollWidth = $container[0].scrollWidth;
				const clientWidth = $container[0].clientWidth;

				if (scrollWidth <= clientWidth) {
					$overflowScroll.removeClass('has-overflow');
					$prefNext.hide();
					$scrollLeft.css('visibility', 'hidden');
					$scrollRight.css('visibility', 'hidden');
					$items.last().css('margin-right', '0px');
					return;
				} else {
					$overflowScroll.addClass('has-overflow');
					$prefNext.show();
					const marginRightValue = $prefNext.outerWidth() * 0.8;
					$items.last().css('margin-right', marginRightValue + 'px');
				}

				const containerRect = $container[0].getBoundingClientRect();
				const lastItemRect = $items.last()[0].getBoundingClientRect();
				const currentScroll = $container.scrollLeft();

				if (lastItemRect.right <= containerRect.right + 1) {
					if (currentScroll > 0) {
						$scrollLeft.css('visibility', 'visible');
						$scrollRight.css('visibility', 'hidden');
					} else {
						$scrollLeft.css('visibility', 'hidden');
						$scrollRight.css('visibility', 'visible');
					}
				} else if (currentScroll <= 0) {
					$scrollLeft.css('visibility', 'hidden');
					$scrollRight.css('visibility', 'visible');
				} else {
					$scrollLeft.css('visibility', 'visible');
					$scrollRight.css('visibility', 'visible');
				}
			}

			// This function handles the smooth scrolling animation.
			function scrollContainer(direction) {
				const currentScroll = $container.scrollLeft();
				const scrollAmount = direction === 'left' ? -(itemWidth + gapValue) : (itemWidth + gapValue);
				animating = true;
				$container.stop().animate({
					scrollLeft: currentScroll + scrollAmount // <-- KORRIGIERTE ZEILE
				}, {
					duration: 600,
					easing: 'easeOutQuint',
					complete: function() {
						animating = false;
						updateButtons();
					}
				});
			}

			// Attach a click event listener to the left scroll button.
			$scrollLeft.on('click', function() {
				if (!animating) scrollContainer('left');
			});

			// Attach a click event listener to the right scroll button.
			$scrollRight.on('click', function() {
				if (!animating) scrollContainer('right');
			});

			// Attach a scroll event listener to the container itself.
			$container.on('scroll', function() {
				if (!animating) updateButtons();
			});

			// Add trackpad swipe functionality for non-touch devices.
			if ($('body').hasClass('none-touch-device')) {
				// A flag to throttle the wheel event to create a snappy feel.
				let wheelReady = true;

				$container.on('wheel', function(e) {
					// Check if the scroll is primarily horizontal.
					if (Math.abs(e.originalEvent.deltaX) > Math.abs(e.originalEvent.deltaY)) {
						// Prevent the default browser scroll.
						e.preventDefault();

						// Trigger scroll only if the throttle is ready.
						if (wheelReady) {
							// Immediately disable the throttle to prevent rapid-fire events.
							wheelReady = false;

							if (e.originalEvent.deltaX > 0) {
								scrollContainer('right');
							} else {
								scrollContainer('left');
							}

							// Re-enable the throttle after a short cooldown period.
							setTimeout(function() {
								wheelReady = true;
							}, 250); // This value controls the responsiveness.
						}
					}
				});
			}

			// Initial check to set the correct state on page load.
			updateButtons();
			// Re-check the state whenever the window is resized.
			$(window).on('resize', function() {
				updateButtons();
			});
		});


	});

	// -------------------------------------------
	// event form validation 
	// moved to event registration plugin 


	function updateGradientHeight() {
		let event_list_height = $('.events .event-list ul').outerHeight();
		let vh = $(window).height();
		let min_margin_top = $('.events .content-wrapper').outerHeight(true) - event_list_height + 'px';

		// console.log('event_list_height: ' + event_list_height + ' | ' + 'vh ' + vh);

		if (event_list_height < vh) {
			$('.events .gradient-background').css('height', event_list_height).css('margin-top', min_margin_top).css('margin-bottom', '0');
			// console.log('limit height')
		} else {
			$('.events .gradient-background').removeAttr('style');
			// console.log(' height reset');
		}
	}

	updateGradientHeight();


	// -------------------------------------------
	// copy (event) url to clipboard
	$('.copy-url-to-clipboard').on('click', function(e) {
		e.preventDefault();
		const $btn = $(this);
		const urlToCopy = $btn.attr('href');

		const $tempInput = $('<input>');
		$('body').append($tempInput);
		$tempInput.val(urlToCopy).select();

		try {
			const successful = document.execCommand('copy');
			if (successful) {
				// visual feedback
				$btn.stop().animate({ opacity: 0.3 }, 50).animate({ opacity: 1 }, 150);
			}
		} catch (err) {
			console.error('Kopierfehler:', err);
		}

		$tempInput.remove();

		// If clicked within a jobs-item, also open the toggle content by triggering the toggle button
		const $jobs_item = $btn.closest('.jobs-item');
		if ($jobs_item.length > 0) {
			const $toggle_button = $jobs_item.find('.toggle-button').first();

			// Only trigger click if currently closed
			if ($toggle_button.length > 0 && !$toggle_button.hasClass('is-open')) {
				$toggle_button.trigger('click');
			}
		}
	});
	// -------------------------------------------

	// Open job accordion if page is loaded with a hash
	function openJobFromHash() {
		const hash = window.location.hash;
		if (hash) {
			const $target = $(hash);
			if ($target.length > 0 && $target.hasClass('jobs-item')) {
				const $toggle_button = $target.find('.toggle-button').first();
				if ($toggle_button.length > 0 && !$toggle_button.hasClass('is-open')) {
					// Small delay to ensure page is fully loaded
					setTimeout(function() {
						$toggle_button.trigger('click');
					}, 300);
				}
			}
		}
	}

	// Call on page load
	$(window).on('load', openJobFromHash);

	// Also call on hash change (when user clicks a link with hash on same page)
	$(window).on('hashchange', openJobFromHash);

	// -------------------------------------------




	// press access -------------------------------------------------------------------------------------
	function ajax_press_access(honeypot, first_name, surename, email, medium, press_release_id, press_access_cookie_consent) {
		// console.log('ajax access start');

		$('.press-material-access-from .loader').show();

		// ------------------------------------------------------------------------------------------------
		// consent with devowl.io Real Cookie Banner 
		// https://docs.devowl.io/real-cookie-banner/js/modules/_frontend_packages_cookie_consent_web_client_src_api_consent_.html

		// 		var sgnPressAccess = false;
		// 
		// 		(window.consentApi && window.consentApi.consent("http", "sgn-press-access", ".seckenberg.de") || Promise.resolve()).then(function() {
		// 			// console.log("sgn-press-access = true");
		// 			sgnPressAccess = true;
		// 		}, function() {
		// 			// console.log("sgn-press-access = false");
		// 			sgnPressAccess = false;
		// 		});
		// 
		// 		console.log("sgn-press-access: " + sgnPressAccess);
		// 		var sgnPressAccess = false;
		// 		var cookie_consent = false
		// 
		// 		// Get current domain dynamically (with leading dot for subdomains)
		// 		const domain = '.' + window.location.host;
		// 
		// 		// Use actual API call or fallback stub
		// 		var consentPromise;
		// 		if (window.consentApi && typeof window.consentApi.consent === 'function') {
		// 			// If the plugin is active, request consent for this domain
		// 			consentPromise = window.consentApi.consent('http', 'sgn-press-access', domain);
		// 		} else {
		// 			// If plugin not active: always allow access
		// 			consentPromise = Promise.resolve();
		// 		}
		// 
		// 		// Handle asynchronous flow
		// 		consentPromise
		// 			.then(function() {
		// 				// Consent granted: set access flag to true
		// 				sgnPressAccess = true;
		// 				cookie_consent = true;
		// 				console.log('sgn-press-access:', sgnPressAccess);
		// 			})
		// 			.catch(function() {
		// 				// Consent denied or failed: set access flag to false
		// 				sgnPressAccess = false;
		// 				cookie_consent = false;
		// 				console.log('sgn-press-access:', sgnPressAccess);
		// 			});
		// 			



		// 		var press_access_cookie_consent = false
		// 
		// 		// Get current domain dynamically (with leading dot for subdomains)
		// 		const domain = '.' + window.location.host;
		// 
		// 		// Use actual API call or fallback stub
		// 		var consentPromise;
		// 		if (window.consentApi && typeof window.consentApi.consent === 'function') {
		// 			// If the plugin is active, request consent for this domain
		// 			consentPromise = window.consentApi.consent('http', 'sgn-press-access', domain);
		// 		} else {
		// 			// If plugin not active: always allow access
		// 			consentPromise = Promise.resolve();
		// 		}
		// 
		// 		// Handle asynchronous flow
		// 		consentPromise
		// 			.then(function() {
		// 				// Consent granted: set access flag to true
		// 				press_access_cookie_consent = true;
		// 				console.log('press_access_cookie_consent:', press_access_cookie_consent);
		// 			})
		// 			.catch(function() {
		// 				// Consent denied or failed: set access flag to false
		// 				press_access_cookie_consent = false;
		// 				console.log('press_access_cookie_consent:', press_access_cookie_consent);
		// 			});

		// ------------------------------------------------------------------------------------------------

		// htaccess important !!!
		// press access with download from external subdomain requires a modified htaccess on the press website :
		// # press release downloads -----------------------------------------------------
		// 
		// # basic option allow all origin
		// # <IfModule mod_headers.c>
		// #	Header set Access-Control-Allow-Origin: *
		// #	Header set Access-Control-Expose-Headers: Content-Disposition
		// # </IfModule>
		// 
		// # enhanced option allow specific domains
		// <IfModule mod_headers.c>
		// 	# Define a regular expression to match your allowed domains and all their subdomains
		// 	SetEnvIf Origin "^https?://([^.]+\.)?(senckenberg\.de|sgn-dev\.de)$" ACAO_Active=$0
		// 	
		// 	# Set the ACAO header *only* if the Origin matched our regex (env=ACAO_Active)
		// 	# The value of the header is dynamically set to the incoming Origin (%{ACAO_Active}e)
		// 	Header set Access-Control-Allow-Origin %{ACAO_Active}e env=ACAO_Active
		// 	
		// 	# Allow credentials (cookies, etc.) to be sent (if needed by your JS)
		// 	Header set Access-Control-Allow-Credentials "true" env=ACAO_Active
		// 	
		// 	# Important for caching: Tell proxies/browsers that the response is Origin-dependent
		// 	# Header append Vary "Origin"
		// </IfModule>
		// # -----------------------------------------------------------------------------

		// Disable form inputs and hide the submit button to prevent double submission
		$('#press-access-form input').prop('disabled', true);
		$('#press-access-form textarea').prop('disabled', true);
		$('#press-access-form .submit').hide(100);
		// Show the loader animation
		$('#press-access-form .loader').delay(90).show();

		// Start the main AJAX request to validate the user's data
		$.ajax({
			type: 'POST',
			url: sgn_ajax_object.ajax_url, // WordPress AJAX endpoint
			data: {
				action: 'press_access_function', // The wp_ajax_... action hook
				honeypot: honeypot,
				first_name: first_name,
				surename: surename,
				email: email,
				medium: medium,
				press_release_id: press_release_id,
				press_access_cookie_consent: press_access_cookie_consent,
				nonce: sgn_ajax_object.nonce, // Security nonce
			},
		}).done(function(data) {
			// Note: It's often safer to use 'dataType: "json"' in the ajax settings
			// to have jQuery parse this automatically and trigger .fail() on errors.
			var data_all = JSON.parse(data);

			// Extract all response variables
			var access = data_all.access;
			var response_message = data_all.response_message;
			var download_button_html = data_all.download_button_html; // HTML for the download button (fallback)
			var download_label_text = data_all.download_label_text; // Text for the fallback button
			var download_url = data_all.download_url; // The direct URL to the file
			var consent_status = data_all.consent_status;

			// Display the server's response message (e.g., "Success!" or "Invalid email")
			$('#press-access-response-message .message-text').html(response_message);

			// Check if the server granted access
			if (access == true) {
				// --- Access Granted: Prepare UI and start download ---

				// Replace the "request access" button with the actual "download" button
				$('#press-release .press-access-dialog-button').remove();
				$('#press-release .button-wrapper').append(download_button_html);

				// Style the response message as a success
				$('#press-access-response-message').removeClass('error').addClass('success');
				$('#press-access-response-message .error-icon').prop('hidden', true);

				/**
				 * Helper function to extract the filename.
				 * It tries to get it from the 'Content-Disposition' header.
				 * If that fails, it falls back to parsing the filename from the URL itself.
				 */
				function getFileNameFromDisposition(header, url) {
					// Fallback: no header provided
					if (!header) return (url.split('/').pop().split('?')[0] || 'download');

					// Regex to find the filename in the header
					var match = /filename\*?=(?:UTF-8'')?["']?([^;"']+)/i.exec(header);
					if (match) return decodeURIComponent(match[1]);

					// Final fallback if regex fails
					return (url.split('/').pop().split('?')[0] || 'download');
				}

				// --- Programmatic Download using fetch + Blob ---
				// This attempts to download the file automatically for the user.
				fetch(download_url)
					.then(function(response) {
						// Check if the network request itself was successful (e.g., not a 404)
						if (!response.ok) throw new Error('Network error: ' + response.status);

						// Get the Content-Disposition header to find the real filename
						var disposition = response.headers.get('Content-Disposition');

						// Return the file content as a Blob and the disposition header
						return response.blob().then(function(blob) {
							return { blob: blob, disposition: disposition };
						});
					})
					.then(function(result) {
						// --- Download Succeeded ---

						// Get the filename using our helper function
						var filename = getFileNameFromDisposition(result.disposition, download_url);

						// Create an in-memory URL for the downloaded file (Blob)
						var blobUrl = URL.createObjectURL(result.blob);

						// Create a temporary, hidden link (<a> element)
						var a = document.createElement('a');
						a.href = blobUrl;
						a.download = filename; // Set the 'download' attribute to force download
						document.body.appendChild(a);

						// Programmatically click the link to trigger the browser's download dialog
						a.click();

						// Clean up: remove the temporary link and revoke the in-memory URL
						a.remove();
						URL.revokeObjectURL(blobUrl);

						// Update UI to inform the user
						$('#press-access-response-message .message-text').html('Download complete');
						closeLightboxes(); // Assumes this is a function to close the modal
					})
					.catch(function(err) {
						// --- Download Failed (Fallback) ---
						// This catch block handles errors from the fetch() process (e.g., CORS, network failure).

						// Uncomment for debugging:
						// console.error("Programmatic download failed:", err);

						// Hide the loader
						$('#press-access-form .loader').hide();

						// Fallback: Instead of failing silently, show the download button
						// (which was already added to the main page) in the response message area as well.
						// This allows the user to click the button and trigger a normal, browser-native download.
						$('#press-access-response-message .message-text').append('<div class="button-wrapper">' + download_button_html + '<span class="download text">' + download_label_text + '</span></div>');
					});

			} else {
				// --- Access Denied ---
				// The AJAX call was successful, but the server logic denied access (e.g., bad email)

				// Style the response message as an error
				$('#press-access-response-message .error-icon').removeAttr('hidden');
				$('#press-access-response-message').removeClass('success').addClass('error');
			}
		});


	}
	// ------------------------------------------------------------------------------------------------

	// helper: validate one field, return true if valid
	function validate_field($form, $field) {
		var field_id = $field.attr('id');
		var type = $field.attr('type');
		var val = $.trim($field.val());
		var is_valid = true;
		var is_format_err = false;

		// empty / checkbox
		if ($field.is(':checkbox')) {
			if (!$field.prop('checked')) {
				is_valid = false;
			}
		} else if (!val) {
			is_valid = false;
		}
		// email format
		else if (type === 'email') {
			var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			if (!re.test(val)) {
				is_valid = false;
				is_format_err = true;
			}
		}

		// find the two possible error spans
		var $err_req = $form.find('#error-' + field_id);
		// CORRECTED: The format error span ID does not have the 'error-' prefix.
		var $err_format = $form.find('#' + field_id + '-format');

		if (!is_valid) {
			$field.attr('aria-invalid', 'true');
			if (is_format_err) {
				$err_req.attr('hidden', ''); // Hide the 'Required Field' message
				if ($err_format.length) { // Ensure the format error span exists before trying to show it
					$err_format.removeAttr('hidden'); // Show the format error message
				}
			} else {
				$err_format.attr('hidden', ''); // Hide format error message
				$err_req.removeAttr('hidden'); // Show the 'Required Field' message
			}
		} else {
			$field.attr('aria-invalid', 'false');
			$err_req.attr('hidden', '');
			$err_format.attr('hidden', '');
		}

		return is_valid;
	}

	// Helper function to check overall form validity, update summary visibility, and manage submit button state
	function check_and_update_overall_form_validity($form) {
		var has_errors = false;
		var $error_summary = $form.find('#form-error-summary');
		var $submitButton = $form.find('button[type="submit"]'); // Get the submit button

		// Check honeypot field first
		var $honeypotField = $form.find('input[name="email_confirm"]');
		if ($honeypotField.val()) {
			has_errors = true; // If honeypot has a value, consider it an error (likely a bot)
			// No individual error message for honeypot, it just contributes to overall form invalidity
		}

		// Validate all required fields by checking their current aria-invalid status
		// This function does NOT re-validate fields, it only reads their state.
		$form.find('[required]').each(function() {
			var $field = $(this);
			if ($field.attr('aria-invalid') === 'true') {
				has_errors = true;
			}
		});

		if (has_errors) {
			$error_summary.removeAttr('hidden'); // Show the general error summary
			$submitButton.prop('disabled', true); // Disable the submit button
			// Scroll to the top of the form or the error summary if it's not in view
			$('html, body').animate({
				scrollTop: $error_summary.offset().top - 50 // Adjust 50px for padding/offset
			}, 500);
		} else {
			$error_summary.attr('hidden', ''); // Hide the general error summary
			$submitButton.prop('disabled', false); // Enable the submit button
		}

		return !has_errors; // Return true if form is valid, false otherwise
	}

	var $form = $('#press-access-form'); // This variable is used for blur/change listeners
	$form.attr('novalidate', 'novalidate'); // Disable browser's default validation

	// On blur, re-validate that single field for all required inputs
	$form.find('[required]').on('blur', function() {
		validate_field($form, $(this));
		// Only update the overall form validity and button state based on current field states
		check_and_update_overall_form_validity($form);
	});

	// On change, re-validate the privacy checkbox and honeypot (if applicable)
	$form.find('.confirm-privacy, input[name="email_confirm"]').on('change', function() {
		// For the privacy checkbox, run individual validation
		if ($(this).is('.confirm-privacy')) {
			validate_field($form, $(this));
		}
		// For honeypot, no individual error message, just update overall form validity
		check_and_update_overall_form_validity($form);
	});

	// Original submit handler for #press-access-form, now with validation integrated at the beginning
	$('#press-access-form').on('submit', function(e) {
		// --- Start of Validation Logic (Supplement) ---
		// Use $(this) to refer to the current form within this handler
		var $currentForm = $(this);

		// Perform overall form validation and get the result
		// This call will now re-validate all required fields for emptiness and format,
		// ensuring the form is fully checked before submission.
		var form_is_valid = true;
		$currentForm.find('[required]').each(function() {
			var $field = $(this);
			if (!validate_field($currentForm, $field)) { // Re-validate each field on submit
				form_is_valid = false;
			}
		});

		// Also check honeypot on submit
		var $honeypotField = $currentForm.find('input[name="email_confirm"]');
		if ($honeypotField.val()) {
			form_is_valid = false; // Honeypot filled, consider form invalid
		}

		// Update overall summary and button state based on the full submit validation
		if (!form_is_valid) {
			$currentForm.find('#form-error-summary').removeAttr('hidden');
			$currentForm.find('button[type="submit"]').prop('disabled', true);
			$('html, body').animate({
				scrollTop: $currentForm.find('#form-error-summary').offset().top - 50
			}, 500);
			e.preventDefault(); // Prevent form submission if there are errors
			return; // Stop execution if validation fails
		} else {
			$currentForm.find('#form-error-summary').attr('hidden', '');
			$currentForm.find('button[type="submit"]').prop('disabled', false);
		}
		// --- End of Validation Logic ---

		// --- Original Submit Handler Logic (Unchanged, executed only if validation passes) ---
		e.preventDefault(); // This is the original preventDefault from the user's code.

		// Formularwerte auslesen
		var press_release_id = $('#press-access-form input[name="press_release_id"]').val();
		var honeypot = $('#press-access-form input[name="email_confirm"]').val();
		var first_name = $('#press-access-form input[name="first_name"]').val();
		var surename = $('#press-access-form input[name="surename"]').val();
		var email = $('#press-access-form input[name="email"]').val();
		var medium = $('#press-access-form textarea[name="medium"]').val();

		// console.log('press_release_id: ' + press_release_id);
		// console.log('honeypot: ' + honeypot);
		// console.log('first_name: ' + first_name);
		// console.log('surename: ' + surename);
		// console.log('email: ' + email);
		// console.log('medium: ' + medium);

		// real cookie banner consent for press cookie	
		// Consent-Promise erzeugen
		var domain = '.' + window.location.host;
		var consentPromise = (window.consentApi && typeof window.consentApi.consent === 'function') ?
			window.consentApi.consent('http', 'sgn-press-access', domain) :
			Promise.resolve();

		// Promise in Boolean transformieren und dann einmalig Ajax aufrufen
		consentPromise
			.then(function() { return true; }, function() { return false; })
			.then(function(press_access_cookie_consent) {
				// Assuming ajax_press_access is defined elsewhere in your script
				// This function will only be called if validation passes
				if (typeof ajax_press_access === 'function') {
					ajax_press_access(
						honeypot,
						first_name,
						surename,
						email,
						medium,
						press_release_id,
						press_access_cookie_consent
					);
				} else {
					console.error("Function 'ajax_press_access' is not defined.");
					// Optionally, submit the form normally if ajax_press_access is missing
					// $('#press-access-form').off('submit').submit();
				}
			});
	});


	// helper for select menus with prefix 
	function select_menu_prefix_helper() {
		$('.select-menu.has-prefix').each(function() {
			var prefix_width = $(this).find('.prefix').outerWidth(true);

			$(this).find('select').css({
				position: 'absolute',
				'padding-left': prefix_width,
				'visibility': 'visible'
			});
		});
	}

	var resizeTimer;
	$(window).on('resize', function(e) {
		resizeTimer = setTimeout(function() {
			select_menu_prefix_helper();
		}, 50);
	});

	select_menu_prefix_helper();


	// ------------------------------------------------------------------------------------------------
	// filter for events calendar, press release and jobs 
	$(function() {
		// Universal filtering function
		function filter_select_items(filter_configuration) {

			// collect selected values from all configured selects
			var selected_values = filter_configuration.select_ids.map(function(select_id) {
				return $(select_id).val() || '';
			});

			// get all items to filter and the no-results alert element
			var $items = $(filter_configuration.item_selector);
			var $no_results_alert = $(filter_configuration.no_results_selector);

			// use configured animation duration or default 200ms
			var animation_duration = filter_configuration.animation_duration || 200;

			// track how many items are visible after filtering
			var visible_items_count = 0;

			// loop through items to determine visibility
			$items.each(function() {
				var $current_item = $(this).stop(true, true);

				// extract data attributes from the item as strings
				var item_data_values = filter_configuration.data_keys.map(function(data_key) {
					// .data() can return numbers/objects, so we cast to String
					var val = $current_item.data(data_key);
					return val !== undefined && val !== null ? String(val) : '';
				});

				// check if item matches all selected filter values
				var item_matches = item_data_values.every(function(data_value, index) {
					var selected_value = selected_values[index];

					// an empty selected value means "All", so always match
					if (!selected_value) return true;

					// Split the data attribute by comma and check if the selected value exists in the array
					// Works for: "15" -> ["15"] AND "15,20,30" -> ["15", "20", "30"]
					var values_array = data_value.split(',').map(function(s) { return s.trim(); });
					return values_array.includes(selected_value);
				});

				// show or hide item based on match result
				if (item_matches) {
					visible_items_count++;
					$current_item.fadeIn(animation_duration);
				} else {
					$current_item.fadeOut(animation_duration);
				}
			});

			// show or hide the no-results alert based on visible items
			if (visible_items_count === 0) {
				if ($no_results_alert.prop('hidden')) {
					$no_results_alert
						.hide()
						.prop('hidden', false)
						.fadeIn(animation_duration);
				}
			} else {
				if (!$no_results_alert.prop('hidden')) {
					$no_results_alert.fadeOut(animation_duration, function() {
						$(this).prop('hidden', true);
					});
				}
			}

			// optional callback after filtering
			if (typeof filter_configuration.on_after_filter === 'function') {
				if (filter_configuration.callback_delay) {
					clearTimeout(filter_configuration._callback_timer);
					filter_configuration._callback_timer = setTimeout(
						filter_configuration.on_after_filter,
						filter_configuration.callback_delay
					);
				} else {
					filter_configuration.on_after_filter();
				}
			}
		}

		// Press filter configuration ------------------------------
		var press_filter_configuration = {
			select_ids: ['#press_year', '#press_section'],
			item_selector: '.press-teaser-item',
			no_results_selector: '#press-filter-alert',
			data_keys: ['year', 'section-id'],
			animation_duration: 200
		};

		var $press_filter_selects = $('#press_year, #press_section');
		$press_filter_selects.on('change', function() {
			filter_select_items(press_filter_configuration);
		});
		filter_select_items(press_filter_configuration);


		// Event filter configuration ----------------------------
		var event_filter_configuration = {
			select_ids: ['#event_month', '#event_type', '#event_target_group'],
			item_selector: '.event-item',
			no_results_selector: '#events-filter-alert',
			data_keys: ['month', 'eventTypeId', 'targetGroupLocationId'],
			animation_duration: 200,
			// on_after_filter: updateGradientHeight, // Stellen Sie sicher, dass diese Funktion existiert
			callback_delay: 500
		};

		var $event_filter_selects = $('#event_month, #event_type, #event_target_group');
		$event_filter_selects.on('change', function() {
			filter_select_items(event_filter_configuration);
		});
		filter_select_items(event_filter_configuration);


		// jobs filters ---------------------------------------------
		var jobs_filter_configuration = {
			select_ids: ['#jobs-group-select', '#jobs-location-select'],
			item_selector: '.jobs-item',
			no_results_selector: '#jobs-filter-alert',
			data_keys: ['group', 'location'],
			animation_duration: 200,
			callback_delay: 500
		};

		var $jobst_filter_selects = $('#jobs-group-select, #jobs-location-select');
		$jobst_filter_selects.on('change', function() {
			filter_select_items(jobs_filter_configuration);
		});
		filter_select_items(jobs_filter_configuration);
	});


	// ------------------------------------------------------------------------------------------------
	// slider 
	$('.exhibition-slider .slider').each(function() {
		const $slider = $(this);
		const $items = $slider.find('.item');
		const itemCount = $items.length;
		let currentIndex = 0;
		let isAnimating = false;
		const animationDuration = 1200;

		if (itemCount <= 1) {
			$slider.find('.prev-next').hide();
			return;
		}

		function setSliderState(newIndex) {
			currentIndex = newIndex;
			$slider.removeClass('is-first-slide is-last-slide');
			if (currentIndex === 0) {
				$slider.addClass('is-first-slide');
			}
			if (currentIndex === itemCount - 1) {
				$slider.addClass('is-last-slide');
			}

			$items.each(function(i) {
				const $item = $(this);
				$item.removeClass('is-active is-viewed is-hidden-prev is-next is-upcoming');
				if (i === currentIndex) $item.addClass('is-active');
				else if (i === currentIndex - 1) $item.addClass('is-viewed');
				else if (i < currentIndex) $item.addClass('is-hidden-prev');
				else if (i === currentIndex + 1) $item.addClass('is-next');
				else $item.addClass('is-upcoming');
			});
		}

		const $nextButton = $slider.find('.button.next');
		const $prevButton = $slider.find('.button.prev');

		// -- "Next" Button Handler --
		$nextButton.on('click', function() {
			if (isAnimating || currentIndex >= itemCount - 1) return;
			isAnimating = true;

			const $currentSlide = $items.filter('.is-active');
			const $nextSlide = $items.filter('.is-next');
			const $upcomingSlide = $items.eq(currentIndex + 2);

			$currentSlide.addClass('is-fading-out-shadow');
			$nextSlide.addClass('is-animating-in');
			if ($upcomingSlide.length) {
				$upcomingSlide.addClass('is-becoming-next');
			}

			$nextSlide.one('animationend', function() {
				$items.removeClass('is-animating-in is-becoming-next is-fading-out-shadow');
				setSliderState(currentIndex + 1);
				isAnimating = false;
			});
		});

		// -- "Prev" Button Handler --
		$prevButton.on('click', function() {
			if (isAnimating || currentIndex <= 0) return;
			isAnimating = true;

			const $currentSlide = $items.filter('.is-active');
			const $prevSlide = $items.eq(currentIndex - 1);

			$currentSlide.addClass('is-animating-out');
			$prevSlide.addClass('is-revealing-shadow');

			$currentSlide.one('animationend', function() {
				$items.removeClass('is-animating-out is-revealing-shadow');
				setSliderState(currentIndex - 1);
				isAnimating = false;
			});
		});

		// -- Click on Next Slide to Navigate --
		$slider.on('click', '.item.is-next', function(event) {
			event.preventDefault();
			$nextButton.click();
		});

		// -- Keyboard Controls --
		$slider.on('keydown', function(event) {
			if (isAnimating) return;
			if (event.key === 'ArrowRight') {
				event.preventDefault();
				$nextButton.click();
			}
			if (event.key === 'ArrowLeft') {
				event.preventDefault();
				$prevButton.click();
			}
		});

		// -- Touch Swipe Controls --
		let touchstartX = 0,
			touchstartY = 0,
			preventClick = false;
		const sliderElement = $slider[0];

		sliderElement.addEventListener('touchstart', e => {
			touchstartX = e.changedTouches[0].screenX;
			touchstartY = e.changedTouches[0].screenY;
		}, {
			passive: true
		});
		sliderElement.addEventListener('touchmove', () => {
			preventClick = true;
		}, {
			passive: true
		});
		$slider.on('touchend', function(event) {
			if (isAnimating) return;
			const deltaX = event.changedTouches[0].screenX - touchstartX;
			const deltaY = event.changedTouches[0].screenY - touchstartY;
			if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 40) {
				preventClick = true;
				deltaX > 0 ? $prevButton.click() : $nextButton.click();
			}
		});
		$slider.on('click', 'a', function(event) {
			if (preventClick) {
				event.preventDefault();
				preventClick = false;
			}
		});

		// Initialize Slider
		setSliderState(0);
	});


	// -----------------------------------------------------------------------------------------------
	// mediathek load more 
	$('.mediathek-archive').on('click', '.load-more', function(e) {
		e.preventDefault();

		const $button = $(this);
		const $load_spinner = $button.parent().find('.loader');

		// Extract data attributes from the button
		const segment_slug = $button.data('segment');
		const section_term_slug = $button.data('section-term-slug');
		const page = parseInt($button.data('page')) || 1;
		const max_pages = parseInt($button.data('max-pages')) || 1;
		const posts_per_page = parseInt($button.data('post-per-page')) || -1;

		// console.log('posts_per_page: ' + posts_per_page);

		// Find containers for cards and lightboxes
		const $lightbox_container = $button.closest('.term-section').find('.lightboxes');
		const $cards_container = $button.closest('.term-section').find('.cards');


		$.ajax({
			type: 'POST',
			url: sgn_ajax_object.ajax_url,
			data: {
				action: 'mediathek_load_more_posts',
				segment_slug: segment_slug,
				section_term_slug: section_term_slug,
				page: page,
				posts_per_page: posts_per_page,
				nonce: sgn_ajax_object.nonce,
			},
			beforeSend: function() {
				$button.hide(50);
				$load_spinner.show(50);


			},
			success: function(response) {
				if (response) {
					let data;
					try {
						data = typeof response === 'string' ? JSON.parse(response) : response;
					} catch (err) {
						console.error('Invalid JSON response:', err);
						return;
					}
					// console.log(data.debug)
					// console.log(data.cards)

					// Append new content
					$cards_container.append(data.cards);
					$lightbox_container.append(data.lightboxes);

					$load_spinner.hide(50);
					$button.show(50);

					// Update page number
					const nextPage = page + 1;
					$button.data('page', nextPage);



					// Hide button if max pages reached
					if (nextPage > max_pages) {
						$button.hide();
					}
				} else {
					$button.hide();
				}
			},
			complete: function() {
				// Optional: reset button state
				// $button.text('Load more').prop('disabled', false);
			},
			error: function(error) {
				console.error('AJAX error:', error);
				// Optional: show error message
				// $button.text('Error loading content');			
			}
		});
	});


	// -----------------------------------------------------------------------------------------------
	// members news blog load more 

	$('.members-news-archive').on('click', '.load-more', function(e) {
		e.preventDefault();

		const $button = $(this);
		const $cards_container = $('.members-news-archive .cards');

		// Extract data attributes from the button
		const anchor_section_term_slug = $button.data('anchor_section-term-slug') || '';
		const page = parseInt($button.data('page')) || 1;
		const posts_per_page = parseInt($button.data('post-per-page')) || -1;


		$.ajax({
			type: 'POST',
			url: sgn_ajax_object.ajax_url,
			data: {
				action: 'members_news_load_more_posts',
				anchor_section_term_slug: anchor_section_term_slug,
				page: page,
				posts_per_page: posts_per_page,
				nonce: sgn_ajax_object.nonce,
			},
			success: function(response) {
				if (response) {
					let data;
					try {
						data = typeof response === 'string' ? JSON.parse(response) : response;
					} catch (err) {
						console.error('Invalid JSON response:', err);
						return;
					}

					$cards_container.append(data.cards);

					// Get the new total number of pages from the response
					const new_max_pages = parseInt(data.max_pages) || 1;
					// Update the button's max-pages data for future checks
					$button.data('max-pages', new_max_pages);

					// Increment the page number for the next "Load More" click
					const nextPage = page + 1;
					$button.data('page', nextPage);

					// Hide the button if the last page has been reached
					if (nextPage > new_max_pages) {
						$button.hide();
					}
				} else {
					// If there's no response, hide the button
					$button.hide();
				}
			},
			error: function(error) {
				console.error('AJAX error:', error);
			}
		});
	});



	// -----------------------------------------------------------------------------------------------
	// members news filter select

	$('.members-news-archive').on('change', '#members-news-anchor_sections-filter', function() {
		const $button = $('.members-news-archive .load-more');
		const $cards_container = $('.members-news-archive .cards');

		const anchor_section_term_slug = $(this).children("option:selected").val();

		// Always reset to page 1 for a new filter
		const page = 1;
		const posts_per_page = parseInt($button.data('post-per-page')) || -1;

		// Update the button's data attribute with the new slug for subsequent "Load More" clicks
		$button.data('anchor_section-term-slug', anchor_section_term_slug);


		$.ajax({
			type: 'POST',
			url: sgn_ajax_object.ajax_url,
			data: {
				action: 'members_news_load_more_posts',
				anchor_section_term_slug: anchor_section_term_slug,
				page: page,
				posts_per_page: posts_per_page,
				nonce: sgn_ajax_object.nonce,
			},
			success: function(response) {
				if (response) {
					let data;
					try {
						data = typeof response === 'string' ? JSON.parse(response) : response;
					} catch (err) {
						console.error('Invalid JSON response:', err);
						return;
					}

					$cards_container.html(data.cards);

					$button.show();

					// Get the new total number of pages for the filtered query
					const new_max_pages = parseInt(data.max_pages) || 1;
					// Update the button's max-pages data
					$button.data('max-pages', new_max_pages);

					// Set the next page to be loaded to 2
					const nextPage = 2;
					$button.data('page', nextPage);

					// Hide the button if there is only one page of results for this filter
					if (nextPage > new_max_pages) {
						$button.hide();
					}
				} else {
					// If no results, empty the container and hide the button
					$cards_container.html('');
					$button.hide();
				}
			},
			error: function(error) {
				console.error('AJAX error:', error);
			}
		});
	});


	// -----------------------------------------------------------------------------------------------
	$(document).on('click', '.print-page', function() {
		window.print();
	});


	//--------------------------------------------------------------------------------------------------
	// window load functions
	$(window).on('load', function() {
		setTimeout(function() {
			updateGradientHeight();
		}, 300);
	});

	//--------------------------------------------------------------------------------------------------
	// all resize functions
	var resizeTimer;
	$(window).on('resize', function(e) {
		resizeTimer = setTimeout(function() {
			classMobile();
			tableFixedColumn();
			updateGradientHeight();
			mobile_nav_height_helper();
		}, 700);
	});
	// -------------------------------------------------------------------------------------
})(jQuery);